// extracted by mini-css-extract-plugin
export var li = "_vr-2";
export var ol = "_vr-1";
export var ul = "_vr-0";